import { TableCell, styled } from '@mui/material';

type Props = {
  isError: boolean;
};

const CustomTableCell = styled(TableCell)<Props>`
  padding: 6px 24px 6px 4px;
  padding-right: ${({ isError }) => (isError ? 0 : '24px')};
`;

export default CustomTableCell;
